import React from 'react';
import { Link } from 'react-router-dom';
import './WhitePaneFooter.css';

const footerLinks = [
  {
    heading: 'Company',
    links: [
      { label: 'About Us', url: '/about-us', isExternal: false },
    ],
  },
  {
    heading: 'Affiliates',
    links: [
      { label: 'Sell With Us', url: '/sell-with-us', isExternal: false },
    ],
  },
  {
    heading: 'Support',
    links: [
      { label: 'Help & Support', url: '/help', isExternal: false },
      { label: 'FAQ', url: '/faq', isExternal: false },
    ],
  },
];

const WhitePaneFooter = () => (
  <footer className="white-pane-footer">
    <div className="footer-main-row">
      <div className="footer-g-col">
        <span className="footer-g-brand">Gradies</span>
      </div>
      <div className="footer-links-row">
        {footerLinks.map((col) => (
          <div className="footer-col" key={col.heading}>
            <div className="footer-col-heading">{col.heading}</div>
            <ul>
              {col.links.map((link) => (
                <li key={link.label}>
                  {link.isExternal ? (
                    <a href={link.url} target="_blank" rel="noopener noreferrer">{link.label}</a>
                  ) : (
                    <Link to={link.url}>{link.label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
    <div className="footer-bottom-row">
      <span className="footer-bottom-center">Gradies 2025</span>
    </div>
  </footer>
);

export default WhitePaneFooter; 